/**
 * Enum to denote different button types in mini
 */
export enum ButtonType {
    'Default',
    'Primary',
    'Inline',
    'InlinePrimary',
    'Link',
    'CommandBar',
}
